import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const StatementExport = ({ onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatement = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/client/statement`);
        setData(res.data);
      } catch (err) {
        console.error("Error fetching statement", err);
      } finally {
        setLoading(false);
      }
    };
    fetchStatement();
  }, []);

  const downloadCSV = () => {
    if (!data) return;

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += "Type,Symbol/Note,Qty,Price/Amount,Status,Date\n";

    (data.orders || []).forEach((o) => {
      csvContent += `TRADE,${o.name},${o.qty},${o.price},${o.status},${new Date(o.createdAt).toLocaleString()}\n`;
    });

    (data.transactions || []).forEach((t) => {
      csvContent += `FUND,${t.type},1,${t.amount},${t.status},${new Date(t.requestedAt).toLocaleString()}\n`;
    });

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", `OpenBull_Statement_${new Date().toISOString().slice(0, 10)}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <h3 style={{ margin: 0, color: "#333" }}>📄 Account Statement & Contract Note</h3>
          <button onClick={onClose} style={{ border: "none", background: "none", fontSize: "18px", cursor: "pointer" }}>✕</button>
        </div>

        {loading ? (
          <p>Generating statement data...</p>
        ) : (
          <div>
            <p style={{ fontSize: "13px", color: "#666" }}>
              Statement generated at {new Date(data?.generatedAt).toLocaleString()}
            </p>

            <div style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #eee", padding: "10px", borderRadius: "6px", marginBottom: "16px" }}>
              <h4 style={{ margin: "0 0 8px 0", fontSize: "14px" }}>Trade Orders ({data?.orders?.length || 0})</h4>
              <ul style={{ paddingLeft: "18px", fontSize: "13px", color: "#444", margin: 0 }}>
                {(data?.orders || []).map((o) => (
                  <li key={o._id} style={{ marginBottom: "4px" }}>
                    <strong>{o.mode}</strong> {o.qty} qty of <strong>{o.name}</strong> @ ₹{o.price} ({new Date(o.createdAt).toLocaleDateString()})
                  </li>
                ))}
              </ul>

              <h4 style={{ margin: "16px 0 8px 0", fontSize: "14px" }}>Fund Movements ({data?.transactions?.length || 0})</h4>
              <ul style={{ paddingLeft: "18px", fontSize: "13px", color: "#444", margin: 0 }}>
                {(data?.transactions || []).map((t) => (
                  <li key={t._id} style={{ marginBottom: "4px" }}>
                    <strong>{t.type.replace(/_/g, " ").toUpperCase()}</strong> ₹{t.amount} ({t.status})
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button onClick={onClose} style={btnGreyStyle}>Close</button>
              <button onClick={downloadCSV} style={btnGreenStyle}>📥 Export to CSV</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "24px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "520px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
};

const btnGreyStyle = {
  padding: "10px 16px",
  backgroundColor: "#eee",
  color: "#333",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const btnGreenStyle = {
  padding: "10px 18px",
  backgroundColor: "#4caf50",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontWeight: "bold",
  cursor: "pointer",
};

export default StatementExport;
